// extracted by mini-css-extract-plugin
export default {"modal":"bulk-send-sms-modal_modal__B9DBu"};